module.exports = __webpack_public_path__ + "static/media/charger-pin-private.4e9c585f.svg";